























import { Component, Prop, Vue } from "vue-property-decorator";
import Entry from "@/models/Entry";
import EntryItem from "@/components/EntryItem.vue";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import { Company, Brand, Product, ClientAgentProduct } from "@/models";
import ClientCompany from "@/models/Agents/Company";

@Component({
  components: {
    LogoWithFallback,
    EntryItem,
  },
})
export default class EntryListVariant extends Vue {
  @Prop() readonly items!: Entry[] | ClientCompany[] | ClientAgentProduct[];
  @Prop() readonly canAdd?: (item: Entry) => boolean;
  @Prop({ default: true }) readonly actions?: boolean;
  @Prop({ default: false }) readonly selectable?: boolean;
  @Prop({ default: "" }) readonly title?: string;

  add(value: Company | Brand | Product | ClientCompany | ClientAgentProduct) {
    this.$emit("add", value);
  }

  remove(
    value: Company | Brand | Product | ClientCompany | ClientAgentProduct
  ) {
    this.$emit("remove", value);
  }

  select(
    value: Company | Brand | Product | ClientCompany | ClientAgentProduct
  ) {
    if (this.selectable === false) {
      return;
    }

    this.$emit("selected", value);
  }

  getWrapperClass() {
    const classes: string[] = [];

    if (this.selectable) {
      classes.push("entry-list--selectable");
    }

    return classes;
  }
}
